export enum DriversType {
	folder = 'driversFolder',
	drivers = 'drivers',
	drivers_template = 'drivers_template'
}
